import React, { Fragment } from 'react'
import estilos from './Documentacion.module.css'
import { v4 as uuidv4 } from 'uuid';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux'
import IconButton from '@mui/material/IconButton';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';
import BlockRoundedIcon from '@mui/icons-material/BlockRounded';
import BotonHistorialComponent from './BotonesComponent/BotonHistorialComponent';
import BotonSustituirComponent from './BotonesComponent/BotonSustituirComponent';
import BotonVerArchivosComponent from './BotonesComponent/BotonVerArchivosComponent';
import BotonDocumentoValidoComponent from './BotonesComponent/BotonDocumentoValidoComponent';
import { obtenerTodoHistorialCliente } from '../../../../../redux/DucksAtencionACliente/ModuloConsultaDucks';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import moment from 'moment';
import Tooltip from '@mui/material/Tooltip';

function DocumentacionMarcasBebidasMezcalComponent(props) {
    let detalleCliente = props?.detalle
    console.log('detalleCliente: ', detalleCliente)
    const dispatch = useDispatch()
    const fechaHoy = moment().format('YYYY-MM-DD')
    const usuarioCompleto = useSelector(store => store.Usuario.user)
    let rowsDocumentacionMarcasBebidasMezcal = []

    for (const datos in detalleCliente.marcasproductoconmezcalcliente) {
        if (rowsDocumentacionMarcasBebidasMezcal.includes(detalleCliente?.marcasproductoconmezcalcliente?.[datos]?.marca) == false) {
            rowsDocumentacionMarcasBebidasMezcal.push({ id: uuidv4(), nameDoc: (detalleCliente?.marcasproductoconmezcalcliente?.[datos]?.marca).toUpperCase() })
        }
        let tipoMarca = ''
        if (detalleCliente.marcasproductoconmezcalcliente[0].idtipomarca === 1) tipoMarca = 'Mixta'
        if (detalleCliente.marcasproductoconmezcalcliente[0].idtipomarca === 2) tipoMarca = 'Nominativa'
        if (detalleCliente.marcasproductoconmezcalcliente[0].idtipomarca === 3) tipoMarca = 'Tridimencional'

        let tirularidad = ''
        if (detalleCliente.marcasproductoconmezcalcliente[0].idtitularidaddemarca === 1) tirularidad = 'Marca propia'
        if (detalleCliente.marcasproductoconmezcalcliente[0].idtitularidaddemarca === 2) tirularidad = 'Marca propia en tramite'
        if (detalleCliente.marcasproductoconmezcalcliente[0].idtitularidaddemarca === 3) tirularidad = 'Marca de licencia de uso autorizado'
        if (detalleCliente.marcasproductoconmezcalcliente[0].idtitularidaddemarca === 4) tirularidad = 'Marca cesion de derechos autorizada'
        if (detalleCliente.marcasproductoconmezcalcliente[0].idtitularidaddemarca === 5) tirularidad = 'Marca de licencia de uso en tramite'
        if (detalleCliente.marcasproductoconmezcalcliente[0].idtitularidaddemarca === 6) tirularidad = 'Marca cesion de derechos en tramite'

        for (const i in detalleCliente.marcasproductoconmezcalcliente[datos].archivosmarcasproductocliente) {

            let alertaFechaVencimiento = ''
            let diasFaltantesVencimiento = ''
            if (detalleCliente?.marcasproductoconmezcalcliente?.[datos]?.archivosmarcasproductocliente?.[i]?.fechafin !== null) {
                diasFaltantesVencimiento = moment(detalleCliente?.marcasproductoconmezcalcliente?.[datos]?.archivosmarcasproductocliente?.[i]?.fechafin?.substring(0, 10)).diff(moment(fechaHoy), 'days')
                if (diasFaltantesVencimiento > 5) {
                    alertaFechaVencimiento = 'verde'
                } else if (diasFaltantesVencimiento > 0 && diasFaltantesVencimiento < 6) {
                    alertaFechaVencimiento = 'amarillo'
                } else if (diasFaltantesVencimiento == 0 || diasFaltantesVencimiento < 0) {
                    alertaFechaVencimiento = 'rojo'
                }
            } else {
                alertaFechaVencimiento = 'gris'
            }
            const nameId = detalleCliente.marcasproductoconmezcalcliente[datos].archivosmarcasproductocliente[i].nameid
            let nameDoc = ''
            let quitarVigencia = false

            if ((nameId).includes('TITULO')) nameDoc = 'Título de la marca'
            else if ((nameId).includes('LICAUT')) nameDoc = 'Licencia de uso autorizada'
            else if ((nameId).includes('CESAUT')) nameDoc = 'Cesión de derechos autorizada'
            else if ((nameId).includes('LICT')) nameDoc = 'Licencia de uso en trámite'
            else if ((nameId).includes('CRLT')) nameDoc = 'Carta responsiva de licencia de uso en trámite'
            else if ((nameId).includes('CESMT')) nameDoc = 'Cesión de derechos en trámite'
            else if ((nameId).includes('CRCDMT')) nameDoc = 'Carta responsiva de cesión de derechos en trámite'
            else if ((nameId).includes('CM')) nameDoc = 'Comprobante en trámite'
            else if ((nameId).includes('CRMT')) nameDoc = 'Carta responsiva en trámite'
            else if ((nameId).includes('CRMLT')) nameDoc = 'Carta responsiva y licencia de uso en trámite'
            else if ((nameId).includes('CEST')) nameDoc = 'Comprobante de cesión de derechos en trámite'
            else if ((nameId).includes('CRMCT')) nameDoc = 'Carta responsiva y cesión de derechos en trámite'
            else if ((nameId).includes('JE')) nameDoc = 'Juego de etiquetas'
            else if ((nameId).includes('MARCACONMEZCALCONTRATO')) nameDoc = 'Contrato de maquila con un envasador'
            else if ((nameId).includes('MARCACONMEZCALCONVENIO')) nameDoc = 'Convenio de corresponsabilidad autorizado por el IMPI'

            if (nameId.includes('CESAUT') || nameId.includes('CESMT') || nameId.includes('CM') || nameId.includes('CEST') || nameId.includes('JE')) quitarVigencia = true

            rowsDocumentacionMarcasBebidasMezcal.push({
                id: uuidv4(),
                observacion: detalleCliente?.marcasproductoconmezcalcliente?.[datos]?.archivosmarcasproductocliente?.[i]?.observaciones,
                fechaInicio: detalleCliente?.marcasproductoconmezcalcliente?.[datos]?.archivosmarcasproductocliente?.[i]?.fechainicio !== null ? detalleCliente?.marcasproductoconmezcalcliente?.[datos]?.archivosmarcasproductocliente?.[i]?.fechainicio?.substring(0, 10) : '---',
                fechaTermino: detalleCliente?.marcasproductoconmezcalcliente?.[datos]?.archivosmarcasproductocliente?.[i]?.fechafin !== null ? detalleCliente?.marcasproductoconmezcalcliente?.[datos]?.archivosmarcasproductocliente?.[i]?.fechafin?.substring(0, 10) : '---',
                estatus: detalleCliente?.marcasproductoconmezcalcliente?.[datos]?.archivosmarcasproductocliente?.[i]?.estatus !== null ? detalleCliente?.marcasproductoconmezcalcliente?.[datos]?.archivosmarcasproductocliente?.[i]?.estatus?.substring(0, 10) : 'Agregar',
                tabla: 'archivosmarcasproductocliente',
                nombreId: 'idmarcasproductocliente',
                idSolicitud: detalleCliente?.marcasproductoconmezcalcliente?.[datos]?.archivosmarcasproductocliente?.[i]?.idmarcasproductocliente,
                nameid: nameId, nameDoc: nameDoc, /* + ' del paraje: ' + detalleCliente?.marcasproductoconmezcalcliente?.[datos]?.marca, */
                idAnexo: detalleCliente?.marcasproductoconmezcalcliente?.[datos]?.archivosmarcasproductocliente?.[i]?.idarchivosmarcaproducto,
                colorAlertaFecha: alertaFechaVencimiento, quitarVigencia: quitarVigencia,
                isDocumentoValido: detalleCliente?.marcasproductoconmezcalcliente?.[datos]?.archivosmarcasproductocliente?.[i]?.isdocumentovalido
            })
        }
    }

    const columnsDocumentacion = [
        {
            field: 'documentoValido', headerName: '', headerAlign: 'center', width: 40, sortable: false,
            renderCell: (params) =>
            (
                <Fragment>
                    {params.row.tabla &&
                        <Fragment>
                            <BotonDocumentoValidoComponent data={params.row} idcliente={detalleCliente.idcliente} />
                        </Fragment>
                    }
                </Fragment>
            )
        },
        {
            field: 'nameDoc', headerName: '', headerAlign: 'center', width: 430, sortable: false,
            renderCell: (params) =>
            (
                <Fragment>
                    {
                        params.row.tabla ?
                            <div style={{ width: '100%', textAlign: 'left' }}>
                                <label>{`${params.row.nameDoc}`}</label>
                            </div>
                            :
                            <div style={{ width: '100%', padding: '3%' }}>
                                <label className={`${estilos.divisionDocumentacion}`}>{`${params.row.nameDoc}`}</label>
                            </div>
                    }
                </Fragment>
            )
        },
        {
            field: 'fechaTermino', headerName: '', headerAlign: 'center', width: 140, sortable: false,
            renderCell: (params) => (
                <Fragment>
                    {params.row.tabla && params.row.quitarVigencia == true &&
                        <Fragment>
                            <label> Sin vigencia </label>
                        </Fragment>
                    }
                    {params.row.tabla && params.row.quitarVigencia == false &&
                        <Fragment>
                            <label> {`${params.row.fechaTermino}`} </label>
                        </Fragment>
                    }
                </Fragment>
            )
        },
        {
            field: 'archivo', headerName: '', headerAlign: 'center', width: 70, sortable: false,

            renderCell: (params) =>
            (
                <Fragment>
                    {params.row.tabla &&
                        <Fragment>
                            <Tooltip title="Ver documento"><BotonVerArchivosComponent tabla={params.row?.tabla} nombreId={params.row?.nombreId} idSolicitud={params.row?.idSolicitud} nameid={params.row?.nameid} /></Tooltip>
                        </Fragment>
                    }
                </Fragment>
            )
        },
        {
            field: 'historial', headerName: '', headerAlign: 'center', width: 70, sortable: false,
            renderCell: (params) =>
            (
                <Fragment>
                    {params.row.tabla &&
                        <Fragment>
                            <Tooltip title="Ver historial de cambios"><IconButton size="large" onClick={() => { handleModalHistorial(params) }}> <HistoryRoundedIcon fontSize="inherit" style={{ fill: '#2B2B2B' }} /> </IconButton></Tooltip>
                        </Fragment>
                    }
                </Fragment>
            )
        },
        {
            field: 'estatusfecha', headerName: '', headerAlign: 'center', width: 70, sortable: false,
            renderCell: (params) => (
                <Fragment>
                    {params.row.tabla && params.row.colorAlertaFecha == 'verde' && params.row.quitarVigencia == false &&
                        <Fragment>
                            <Tooltip title="Vigente"><IconButton size="large"> <CheckCircleOutlineRoundedIcon fontSize="inherit" style={{ fill: '#8ABE3E' }} /> </IconButton></Tooltip>
                        </Fragment>
                    }
                    {params.row.tabla && params.row.colorAlertaFecha == 'amarillo' && params.row.quitarVigencia == false &&
                        <Fragment>
                            <Tooltip title="Próximo a vencer"><IconButton size="large"> <ErrorOutlineRoundedIcon fontSize="inherit" style={{ fill: '#F4D35E' }} /> </IconButton></Tooltip>                        </Fragment>
                    }
                    {params.row.tabla && params.row.colorAlertaFecha == 'rojo' && params.row.quitarVigencia == false &&
                        <Fragment>
                            <Tooltip title="Vencido"><IconButton size="large"> <ErrorOutlineRoundedIcon fontSize="inherit" style={{ fill: '#DC3545' }} /> </IconButton></Tooltip>
                        </Fragment>
                    }
                    {/*params.row.tabla && params.row.colorAlertaFecha == 'gris' &&
                        <Fragment>
                            <Tooltip title="Sin fechas asignadas"><IconButton size="large"> <BlockRoundedIcon fontSize="inherit" style={{ fill: '#2B2B2B' }} /> </IconButton></Tooltip>
                        </Fragment>
                    */}
                </Fragment>
            )
        },
        {
            field: 'accion', headerName: '', headerAlign: 'center', width: 70, sortable: false,

            renderCell: (params) =>
            (
                <Fragment>
                    {params.row.tabla &&
                        <Fragment>
                            {(usuarioCompleto?.[0]?.tipousuario?.idtipousuario != 2 && usuarioCompleto?.[0]?.tipousuario?.idtipousuario != 1) &&
                                <Tooltip title="Sustituir archivo"><IconButton size="large" onClick={() => sustituir(params)} > <FileUploadRoundedIcon fontSize="inherit" style={{ fill: '#2B2B2B' }} /> </IconButton></Tooltip>
                            }
                        </Fragment>
                    }
                </Fragment>
            )
        },
        {
            field: 'observacion', headerName: '', headerAlign: 'center', width: 300, sortable: false
        },
    ]

    const [openModalHistorial, setOpenModalHistorial] = React.useState(false);
    const [dataHistorial, setDataHistorial] = React.useState([]);
    const [archivo, setArchivo] = React.useState('');

    const handleModalHistorial = async (params) => {
        let data = {}
        if (params.row.tabla === "archivosgeneralescliente") {
            data = { idSolicitud: params.row.idSolicitud, tabla: params.row.tabla }
        } else {
            data = { idSolicitud: params.row.idAnexo, tabla: params.row.tabla }
        }
        let datosObtenidos = await dispatch(obtenerTodoHistorialCliente(data))
        setDataHistorial(datosObtenidos?.payload)
        setArchivo(params?.row?.nameDoc)
        setOpenModalHistorial(true)
    }
    const [openModalSustituir, setOpenModalSustituir] = React.useState(false);
    const [dataSustituir, setDataSustituir] = React.useState([]);

    const sustituir = async (params) => {
        setDataSustituir(params.row)
        setOpenModalSustituir(true)
    }

    return (
        <Fragment >
            <div style={{ fontFamily: 'Montserrat', height: '700px' }}>
                {detalleCliente.marcasproductoconmezcalcliente.length > 0 &&
                    <div style={{ margin: 0, padding: 0 }}>
                        <h5 style={{ textAlign: 'center', fontWeight: 'bold', color: '#7D9A47' }} >Documentación de marcas de bebidas con mezcal.</h5>
                        <Box sx={{ height: '700px', width: '100%', mt: 2 }}>
                            <DataGrid
                                rows={rowsDocumentacionMarcasBebidasMezcal}
                                columns={columnsDocumentacion}
                                rowsPerPageOptions={[50]}
                                headerHeight={0}
                                getRowHeight={() => 'auto'}
                                sx={{
                                    boxShadow: 0,
                                    color: 'black',
                                    border: 0,
                                    backgroundColor: 'white',
                                    fontFamily: 'Montserrat',
                                    '& .MuiDataGrid-columnHeaders': {
                                        backgroundColor: '#4399A4',
                                        color: 'white',
                                        fontFamily: 'Montserrat',
                                        fontWeight: 'bold',
                                        height: '5px'
                                    },
                                    '& .MuiDataGrid-cell': {
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    },
                                }}
                            />
                        </Box>
                    </div>
                }
                {detalleCliente.marcasproductoconmezcalcliente.length == 0 &&
                    <div style={{ height: '700px', margin: 0, padding: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <h5 style={{ fontWeight: 'bold', color: '#7D9A47' }} >No existe documentación registrada.</h5>
                    </div>
                }
            </div>
            {openModalHistorial && <BotonHistorialComponent setOpenModalHistorial={setOpenModalHistorial} dataHistorial={dataHistorial} archivo={archivo} />}
            {openModalSustituir && <BotonSustituirComponent setOpenModalSustituir={setOpenModalSustituir} data={dataSustituir} idcliente={detalleCliente?.idcliente} />}
        </Fragment>
    )
}

export default DocumentacionMarcasBebidasMezcalComponent